import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Haley Halcyon
 * id E0103EBC-20BF-48EA-BC8F-BEF04BF2A581
 * name currency-twd
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/currency-twd.svg
 * tags
 * - Currency 
 * - Banking 
 */
export const CurrencyTwdIcon = createSvgIcon(<><path d="M3,11H21V13H15V19H21V21H15A2,2 0 0,1 13,19V13H10.35L5.73,21L4,20L8.04,13H3V11M5,3H19V5H5V3Z" /></>, 'CurrencyTwdIcon');
export default CurrencyTwdIcon